/**
 * The media set's grid geometry, shared by the grid, its controls and the
 * thumbnails inside it.
 *
 * These have to agree: the column count is derived from `THUMB_MAX`, the
 * optimizer is asked for a source at that same width, and the add control
 * positions itself against the gap the grid actually uses. Kept together so
 * they cannot drift apart.
 */

/** Widest a cell grows to before the grid takes another column. */
export const THUMB_MAX = 164;

/** Gap between cells, and between the rows. */
export const SET_GAP = 8;

/** Rows shown before the rest go behind a "+N" tile. */
export const MAX_ROWS = 2;

/** Delay between each revealed thumbnail when the set expands. */
export const THUMB_STAGGER_MS = 45;

/** Side of the add square that tucks into a free cell. */
export const ADD_BUTTON = 34;

/** Height of the edge tab, and its width once open. */
export const TAB_SIZE = 44;
